import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SimpleTabs from '../../../SimpleTabs';
import ProfileView from './components/ProfileView';
import AnimatedTabs from './components/AnimatedTabs';
import AnimatedLogo from './components/AnimatedLogo';
import useAnimatedTabs from './hooks/useAnimatedComponents';
import useAccountNavValue from '../../hooks/useAccountNavValue';
import useChangeTabs from '../../hooks/useChangeTabs';
import dataTestIds from '~/test/test-ids';

const TopNavTabs = styled(SimpleTabs).withConfig({ componentId: 'sc-27q82b-0' })`
  position: sticky;
  top: -54px;
  z-index: 100;
  overflow: hidden;

  && .tab-flex-container {
    height: 96px;
  }
`;

type Props = {
  viewName?: string;
  userProfile: any;
};

const TopNav = (props: Props) => {
  const { viewName, userProfile } = props;

  const setTabIndex = useChangeTabs();
  const value = useAccountNavValue(viewName);
  useAnimatedTabs(useMemo(() => document.getElementsByClassName('to-be-animated'), []));

  const { t } = useTranslation(['common']);

  return (
    <TopNavTabs onChange={setTabIndex as any} value={value}>
      <AnimatedLogo alt="solv logo" setTabIndex={setTabIndex} src="/images/logo/solv_dark.svg" />

      <AnimatedTabs
        animatedClassName="to-be-animated"
        data-testid={dataTestIds.account.getCareTab}
        label={t('common:nav.tabs.getCare')}
        value={0}
      />

      <AnimatedTabs
        animatedClassName="to-be-animated"
        label={t('common:nav.tabs.visits')}
        value={1}
      />

      <AnimatedTabs
        animatedClassName="to-be-animated"
        data-testid={dataTestIds.account.insuranceTab}
        label={t('common:nav.tabs.insurance')}
        value={3}
      />

      <AnimatedTabs
        animatedClassName="to-be-animated"
        label={t('common:nav.tabs.profile')}
        value={4}
      />

      <ProfileView userProfile={userProfile} />
    </TopNavTabs>
  );
};

export default TopNav;
